/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbExportModulePermissionDto
 */
export interface FcbExportModulePermissionDto {
    /**
     * 
     * @type {boolean}
     * @memberof FcbExportModulePermissionDto
     */
    selected?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FcbExportModulePermissionDto
     */
    idmodule?: number;
    /**
     * 
     * @type {number}
     * @memberof FcbExportModulePermissionDto
     */
    idexport?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FcbExportModulePermissionDto
     */
    nom?: string | null;
}

/**
 * Check if a given object implements the FcbExportModulePermissionDto interface.
 */
export function instanceOfFcbExportModulePermissionDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportModulePermissionDtoFromJSON(json: any): FcbExportModulePermissionDto {
    return FcbExportModulePermissionDtoFromJSONTyped(json, false);
}

export function FcbExportModulePermissionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportModulePermissionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
        'idmodule': !exists(json, 'idmodule') ? undefined : json['idmodule'],
        'idexport': !exists(json, 'idexport') ? undefined : json['idexport'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
    };
}

export function FcbExportModulePermissionDtoToJSON(value?: FcbExportModulePermissionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selected': value.selected,
        'idmodule': value.idmodule,
        'idexport': value.idexport,
        'nom': value.nom,
    };
}

